import { render } from "./MarketingDatatableTDMailingGroupTitle.vue?vue&type=template&id=2c3a7636"
import script from "./MarketingDatatableTDMailingGroupTitle.vue?vue&type=script&lang=js"
export * from "./MarketingDatatableTDMailingGroupTitle.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__